import React, { useState } from 'react';
import { Typography, Button } from '@mui/material';
import Table from '../Table/Table';
import * as XLSX from 'xlsx';

// Define header configurations for different forms
const formHeaders = {
  PreLamination: [
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'subform', displayName: 'Subform' },
    { dbParam: 'table', displayName: 'Table' },
    { dbParam: 'product', displayName: 'Product' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'observation1', displayName: 'Observation 1' },
    { dbParam: 'observation2', displayName: 'Observation 2' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'remark', displayName: 'Remark' },
  ],
  PostLamination: [
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'subform', displayName: 'Subform' },
    { dbParam: 'table', displayName: 'Table' },
    { dbParam: 'product', displayName: 'Product' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'observation1', displayName: 'Observation 1' },
    { dbParam: 'observation2', displayName: 'Observation 2' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'remark', displayName: 'Remark' },
  ],
  BOM: [
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'subform', displayName: 'Subform' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'value', displayName: 'Value' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'remark', displayName: 'Remark' },
    { dbParam: 'reason', displayName: 'Reason' },
  ],
  Stringer: [
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'subform', displayName: 'Subform' },
    { dbParam: 'Section', displayName: 'Section' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' },
    { dbParam: 'line', displayName: 'Line' },
    { dbParam: 'remark', displayName: 'Remark' },
    { dbParam: 'reason', displayName: 'Reason' },
  ],
  LaminationMachine: [
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'Laminator', displayName: 'Laminator' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' },
    { dbParam: 'remark', displayName: 'Remark' }
  ],
  calibrationVerificationOfSecondaryModule: [
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' }
  ],
  PrimaryModuleCalibrationRecord: [
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' }
  ],
  FrameSealantWeightVerification: [
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' }
  ],
  JunctionBoxSealantWeightVerification: [
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'remark', displayName: 'Remark' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' }
  ],
  JunctionBoxPottingMaterial: [
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' },
    { dbParam: 'remark', displayName: 'Remark' },
  ],
  ModuleDimensionCheck: [
    { dbParam: 'Line', displayName: 'Line' },
    { dbParam: 'date', displayName: 'Date' },
    { dbParam: 'form', displayName: 'Form' },
    { dbParam: 'remark', displayName: 'Remark' },
    { dbParam: 'shift', displayName: 'Shift' },
    { dbParam: 'field', displayName: 'Field' },
    { dbParam: 'reason', displayName: 'Reason' },
    { dbParam: 'specifications', displayName: 'Specifications' },
    { dbParam: 'value', displayName: 'Value' }
  ],
};

const NonConformanceTable = ({ data, selectedForms, formMappings, selectedShifts }) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  // Handle sorting
  const handleSort = (dbParam) => {
    const isAsc = orderBy === dbParam && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(dbParam);
  };

  // Filter data by selected forms and shifts
  const filteredData = data.filter((row) => {
    const selectedFormAPINames = selectedForms.map((form) => formMappings[form]).filter(Boolean);
    const isFormMatch = selectedFormAPINames.length === 0 || selectedFormAPINames.includes(row.form);
    const isShiftMatch = selectedShifts.length === 0 || selectedShifts.includes(row.shift);
    return isFormMatch && isShiftMatch;
  });

  // Sort filtered data based on order and orderBy
  const sortedData = [...filteredData].sort((a, b) => {
    if (!orderBy) return 0;
    const aValue = a[orderBy] || '';
    const bValue = b[orderBy] || '';
    if (order === 'asc') {
      return aValue.localeCompare(bValue);
    }
    return bValue.localeCompare(aValue);
  });

  // Get all unique forms in the filtered data
  const uniqueForms = [...new Set(sortedData.map((row) => row.form))];

  // Function to download table as Excel
  const downloadExcel = (sheetName, formData, headers) => {
    // Map headers to display names
    const headerMap = headers.reduce((acc, header) => ({
      ...acc,
      [header.dbParam]: header.displayName
    }), {});

    // Prepare data for Excel
    const excelData = formData.map(row => {
      const newRow = {};
      headers.forEach(header => {
        newRow[header.displayName] = row[header.dbParam] || '';
      });
      return newRow;
    });

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(excelData);
    
    // Auto-size columns
    const colWidths = headers.map(header => ({
      wch: Math.max(
        header.displayName.length,
        ...excelData.map(row => String(row[header.displayName] || '').length)
      )
    }));
    ws['!cols'] = colWidths;

    // Create workbook and add worksheet
    const wb = XLSX.utils.book_new();
    const safeSheetName = sheetName.length > 31 ? sheetName.substring(0, 31) : sheetName;
    XLSX.utils.book_append_sheet(wb, ws, safeSheetName);

    // Generate and download Excel file
    XLSX.writeFile(wb, `${sheetName}_NonConformance.xlsx`);
  };

  return (
    <div>
      {uniqueForms.length === 0 ? (
        <Typography variant="body1" align="center" style={{ margin: '20px 0' }}>
          No data available
        </Typography>
      ) : (
        uniqueForms.map((form) => {
          const headers = formHeaders[form] || formHeaders.PreLamination;
          const formData = sortedData.filter((row) => row.form === form);

          return (
            <div key={form} style={{ marginBottom: '20px' }}>
              <Typography variant="h6" gutterBottom>
                {Object.keys(formMappings).find((key) => formMappings[key] === form) || form}
              </Typography>
              <Button
                variant="contained"
                // color="primary"
                onClick={() => {
                  const displayFormName = Object.keys(formMappings).find((key) => formMappings[key] === form) || form;
                  downloadExcel(displayFormName, formData, headers);
                }}
                style={{ marginBottom: '10px', backgroundColor: '#424752', color: 'white' }}
              >
                Download as Excel
              </Button>
              <Table
                tableHeaders={headers}
                tableData={formData}
                order={order}
                orderBy={orderBy}
                handleSort={handleSort}
              />
            </div>
          );
        })
      )}
    </div>
  );
};

export default NonConformanceTable;